import React from 'react';
import './Footer.css';
import { Link as LinkR } from 'react-router-dom';
import { Link as LinkS } from 'react-scroll';
import { FaFacebookF, FaYoutube, FaInstagram, FaLinkedin, FaPhoneAlt } from 'react-icons/fa';
import { IoLocationSharp } from 'react-icons/io5'
import { IoMailSharp } from 'react-icons/io5'
import { VscTwitter } from 'react-icons/vsc';

function Footer() {
  return (
    <div className='footer-container'>
      <div className='footer-links'>
        <div className='footer-link-wrapper'>
          <div className='footer-link-items' style={{ marginTop: 10 }}>
            <img src="images/logo/logo.png" alt="logo" height="35px" width="175px" />
            <p style={{ marginTop: 20 }}>Aizonix Solutions is an AI-based software development company providing end-to-end solutions, from the raw idea to final product and services in the global software marketplace since 2024.
</p>
          </div>

          <div className='footer-link-items'>
            <h2>Portfolio</h2>
            <LinkS className="LinkS" to='Service' target="_blank">AI Integration</LinkS>
            <LinkS className="LinkS" to='Service' target="_blank">Web Development</LinkS>
            <LinkS className="LinkS" to='Service' target="_blank">Mobile Development</LinkS>
            <LinkS className="LinkS" to='Service' target="_blank">Design & UX Excellence</LinkS>
            <LinkS className="LinkS" to='Service' target="_blank">Plugins</LinkS>

          </div>
        </div>
        <div className='footer-link-wrapper'>
          <div className='footer-link-items'>
            <h2>Quick Links</h2>
            <LinkS className="LinkS" to='Home' target="_blank">Home</LinkS>
            <LinkS className="LinkS" to='Service' target="_blank">Services</LinkS>
            <LinkS className="LinkS" to='Portfolio' target="_blank">Portfolio</LinkS>
            <LinkS className="LinkS" to='Blog' target="_blank">Technology</LinkS>
            <LinkS className="LinkS" to='About' target="_blank">About Us</LinkS>
            <LinkS className="LinkS" to='Contact' target="_blank">Contact Us</LinkS>
          </div>
          <div className='footer-link-items'>
            <h2>Contact Info</h2>
            {/*<p><IoLocationSharp />&nbsp;F-8 markaz Islamabad</p>*/}
            {/*<p><IoMailSharp />&nbsp;aizonixsolutions.official@gmail.com</p>*/}
            {/*<p><FaPhoneAlt />&nbsp;+92 302 5834392</p>*/}
            <LinkR target="_blank">
              <IoLocationSharp />&nbsp;F-8 markaz Islamabad</LinkR>

            <LinkR target="_blank"><IoMailSharp />&nbsp;info@aizonixsolutions.com</LinkR>

            <LinkR target="_blank"><FaPhoneAlt />&nbsp;+92 302 5834392</LinkR>

          </div>
        </div>
      </div>

      <section className='social-media' >
        <div className='social-media-wrap'>

          <ul className="website-rights">
            &copy;{new Date().getFullYear()} Aizonix Solutions | All rights reserved | Privacy Policy
          </ul>

          <div className='social-icons'>
            <LinkR
              className='social-icon-link facebook'
              to={{ pathname: "https://www.facebook.com/" }}
              target="_blank"
              aria-label='Facebook'
            >
              <FaFacebookF />
            </LinkR>
            <LinkR
              className='social-icon-link instagram'
              to={{ pathname: "https://www.instagram.com/" }}
              target='_blank'
              aria-label='Instagram'
            >
              <FaInstagram />
            </LinkR>
            <LinkR
              className='social-icon-link youtube'
              to={{ pathname: "https://www.youtube.com/" }}
              target='_blank'
              aria-label='Youtube'
            >
              <FaYoutube />
            </LinkR>
            <LinkR
              className='social-icon-link twitter'
              to={{ pathname: "https://twitter.com/" }}
              target='_blank'
              aria-label='Twitter'
            >
              <VscTwitter />
            </LinkR>
            <LinkR
              className='social-icon-link twitter'
              to={{ pathname: 'https://www.linkedin.com/company/aizonixsolutions/?viewAsMember=true' }}
              target='_blank'
              aria-label='LinkedIn'
            >
              <FaLinkedin />
            </LinkR>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;